import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  navOpened = false;
  user: User;

  constructor(public auth: AuthService) { }

  ngOnInit(): void {
    this.auth.getUser().then((user: User) => {
      this.user = user;
    })
  }

  logout() {
    this.auth.signOut();
  }

}
